import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';
import { SettingsService } from '../services/settings.service';
import { ImageModel } from '../models/image-model';

@Pipe({
  name: 'image',
  standalone: true,
})
export class ImagePipe implements PipeTransform {
  apiDomain = environment.apiDomain;
  isMobile = false;
  constructor(
    private settingsService: SettingsService,
    @Optional() @Inject('ISMOBILE') protected mobile: boolean,
  ) {
    this.isMobile = mobile;
  }

  transform(
    imageUrl: string,
    imageWidth: number,
    image: ImageModel,
    mode: string = 'fill',
    imageHeight: number = 0,
    ogImage = false,
    quality: number = 100,
    fixedHeight = false,
    useHeightAsMin = false,
  ) {
    // console.log('quality :>> ', quality);
    // console.log('imageUrl :>> ', imageUrl);
    // console.log('imageWidth :>> ', imageWidth);
    // console.log('image.ImageRatio :>> ', image.ImageRatio);
    // console.log('image :>> ', image);
    this.isMobile = this.settingsService.getMobileStatus();
    const imageType = image.PageType;
    if (!imageUrl) {
      return;
    }

    if (environment.imgFxActive && imageWidth !== 0) {
      imageUrl = this.imgFxPath(imageType) + imageUrl;
    } else {
      imageUrl = this.path(imageType) + imageUrl;
    }

    // fix mobile images
    if (this.isMobile) {
      if (imageWidth > 720) {
        imageWidth = 720;
      }
    }

    let size = '';
    let qualityParam = quality < 100 ? '.q-' + quality : '';

    if (environment.imgFxActive && imageWidth !== 0 && image.ImageRatio > 0) {
      const imagePath =
        environment.imgFxDomain.replace('{mode}', mode + '.webp') + imageUrl;
      if (imageHeight > 0) {
        if (fixedHeight) {
          // console.log('imageWidth 2:>> ', imageWidth);
          return imagePath.replace(
            '{size}',
            imageWidth + 'x' + imageWidth + qualityParam,
          );
        }

        if (useHeightAsMin) {
          imageWidth = Math.floor(imageHeight / image.ImageRatio);
        }

        size = imageWidth + 'x' + imageHeight;
        return imagePath.replace('{size}', size + qualityParam);
      }
      if (ogImage) {
        size = '1200x630';
        return imagePath.replace('{size}', size);
      }
      size = imageWidth + 'x' + Math.floor(imageWidth * image.ImageRatio);
      return imagePath.replace('{size}', size + qualityParam);
    }
    return imageUrl.substr(0, 4) === 'http'
      ? imageUrl
      : this.apiDomain + imageUrl;
  }

  path(imageType: number) {
    switch (imageType) {
      case 1:
        // FrontpageImage
        return 'Upload/FrontPage/';
      case 2:
        // CategoryImage
        return 'Upload/Category/';
      case 3:
        // SubCategoryImage
        return 'Upload/SubCategory/';
        break;
      case 4:
        // CaseImage
        return 'Upload/Case/';
        break;
      case 5:
        // IdeaImage
        return 'Upload/Idea/';
        break;
      case 6:
        // AboutPageImage
        return 'Upload/Info/';
        break;
      case 7:
        // FrontpageCategoryImage
        return 'Upload/FrontPage/';
        break;
      case 8:
        // SustainabilityPage
        return 'Upload/Info/';
        break;
      case 9:
        // CompetitionPage
        return 'Upload/Info/';
        break;
      case 10:
        // CustomerPageContent
        return 'Upload/Info/';
        break;
      default:
        return '';
    }
  }

  imgFxPath(imageType: number) {
    switch (imageType) {
      case 1:
        // FrontpageImage
        return 'startside/';
      case 2:
        // CategoryImage
        return 'kategori/';
      case 3:
        // SubCategoryImage
        return 'underkategori/';
        break;
      case 4:
        // CaseImage
        return 'sak/';
        break;
      case 5:
        // IdeaImage
        return 'ide/';
        break;
      case 6:
        // AboutPageImage
        return 'info/';
        break;
      case 7:
        // FrontpageCategoryImage
        return 'startside/';
        break;
      case 8:
        // SustainabilityPage
        return 'info/';
        break;
      case 9:
        // CompetitionPage
        return 'info/';
        break;
      case 10:
        // CustomerPageContent
        return 'info/';
        break;
      default:
        return '';
    }
  }
}
